import { useApp } from '../../state/AppContext';
import { fmt, badge, zebra } from '../../lib/format';
import { cardPad } from '../../lib/ui';

export default function Whpo() {
  const { go, set, L } = useApp();

  const wh = [
    { id: 'PO-2026-0035', desc: 'Spare Parts — Q2 Batch (Engine & Transmission)', sup: 'ACME Union Motors Ltd.', value: 12100000, due: '2026-06-30', gr: 'Pending', inv: 'None', status: 'Pending GR' },
    { id: 'PO-2026-0031', desc: 'Maintenance Services — Factory Equipment', sup: 'Crestline Insurance', value: 2050000, due: '2026-06-20', gr: '2 recorded', inv: '1 invoice(s)', status: 'Active' },
  ];
  const whRows = wh.map((p, i) => {
    const b = badge(p.status);
    return {
      ...p,
      value: fmt(p.value),
      zebra: zebra(i),
      stBg: b.bg,
      stFg: b.fg,
      grColor: p.gr === 'Pending' ? 'var(--color-warning)' : 'var(--color-success)',
      onOpen: () => { set({ openedPo: { id: p.id, desc: p.desc, sup: p.sup, value: fmt(p.value), doa: '', pending: false, status: p.status, createdBy: p.id === 'PO-2026-0035' ? 'Kris P.' : 'Sam K.' } }); go('warehousepodetail'); },
    };
  });

  return (
    <>
      <div style={cardPad(0, 'auto')}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, minWidth: 900 }}>
          <thead>
            <tr style={{ background: 'var(--color-mist)', borderBottom: '1px solid var(--color-border)' }}>
              <th style={{ textAlign: 'left', padding: '11px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('PO Number', 'เลขที่ใบสั่งซื้อ')}</th>
              <th style={{ textAlign: 'left', padding: '11px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Description', 'รายละเอียด')}</th>
              <th style={{ textAlign: 'left', padding: '11px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Supplier', 'ซัพพลายเออร์')}</th>
              <th style={{ textAlign: 'right', padding: '11px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Value', 'มูลค่า')}</th>
              <th style={{ textAlign: 'left', padding: '11px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Delivery Due', 'กำหนดส่งมอบ')}</th>
              <th style={{ textAlign: 'left', padding: '11px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Goods Receipts', 'ใบรับสินค้า')}</th>
              <th style={{ textAlign: 'left', padding: '11px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Invoices', 'ใบแจ้งหนี้')}</th>
              <th style={{ textAlign: 'left', padding: '11px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Status', 'สถานะ')}</th>
              <th style={{ textAlign: 'right', padding: '11px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Actions', 'การดำเนินการ')}</th>
            </tr>
          </thead>
          <tbody>
            {whRows.map((p) => (
              <tr key={p.id} style={{ borderBottom: '1px solid var(--color-border)', background: p.zebra }}>
                <td style={{ padding: '12px 16px', fontFamily: 'var(--font-mono)', fontWeight: 600 }}>{p.id}</td>
                <td style={{ padding: '12px 16px' }}>{p.desc}</td>
                <td style={{ padding: '12px 16px', color: 'var(--color-fg-2)' }}>{p.sup}</td>
                <td style={{ padding: '12px 16px', textAlign: 'right', fontFamily: 'var(--font-mono)', fontWeight: 600 }}>{p.value}</td>
                <td style={{ padding: '12px 16px', fontFamily: 'var(--font-mono)', color: 'var(--color-fg-2)' }}>{p.due}</td>
                <td style={{ padding: '12px 16px', fontWeight: 600, color: p.grColor }}>{L(p.gr, p.gr === 'Pending' ? 'รอดำเนินการ' : p.gr === '2 recorded' ? 'บันทึกแล้ว 2 รายการ' : p.gr)}</td>
                <td style={{ padding: '12px 16px', color: 'var(--color-fg-2)' }}>{L(p.inv, p.inv === 'None' ? 'ไม่มี' : 'ใบแจ้งหนี้ 1 ใบ')}</td>
                <td style={{ padding: '12px 16px' }}>
                  <span style={{ fontSize: 11, fontWeight: 600, padding: '3px 10px', borderRadius: 999, background: p.stBg, color: p.stFg }}>{L(p.status, p.status === 'Pending GR' ? 'รอรับสินค้า' : 'กำลังดำเนินการ')}</span>
                </td>
                <td style={{ padding: '12px 16px', textAlign: 'right' }}>
                  <button onClick={p.onOpen} className="hv-blue" style={{ fontSize: 12, fontWeight: 600, padding: '6px 12px', borderRadius: 'var(--radius-sm)', background: 'var(--color-blue)', color: '#fff' }}>{L('Open', 'เปิด')}</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
